import React from 'react'
import {verify} from '../features/auth/authSlice'
import {useState, useEffect, useRef} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {toast} from 'react-toastify'
import { useNavigate } from 'react-router-dom'

function VerifyUser (){
    // Use array for 6 digits
    const [codeDigits, setCodeDigits] = useState(['', '', '', '', '', '']);
    const inputRefs = useRef([...Array(6)].map(() => React.createRef()));

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const {user, isError, isSuccess, message, verified} = useSelector(state => state.auth)

    useEffect(()=>{
        if(isError){
            
            toast.error(verified)
            toast.error(message)
        }

        if(verified === "approved"){
            toast.success(" You are verified, welcome!", {
                position: toast.POSITION.TOP_CENTER
              });
            navigate('/homedash')
        }
        console.log(verified)


    },[isError,isSuccess,user, message, verified, navigate,dispatch])

    // Handle input for each digit
    const handleChange = (e, idx) => {
        const val = e.target.value.replace(/[^0-9]/g, '').slice(0, 1);
        const newDigits = [...codeDigits];
        newDigits[idx] = val;
        setCodeDigits(newDigits);

        // Move to next input if value entered
        if (val && idx < 5) {
            inputRefs.current[idx + 1].current.focus();
        }
    };

    // Handle backspace to move focus
    const handleKeyDown = (e, idx) => {
        if (e.key === 'Backspace' && !codeDigits[idx] && idx > 0) {
            inputRefs.current[idx - 1].current.focus();
        }
    };

    const onSubmit = (e) =>{
        e.preventDefault()
        const code = codeDigits.join('');
        if(code.length !== 6){
            toast.error("Enter the 6-digit code received")
        }else{
            dispatch(verify({code}))
        }
    }

    return(
    <div className="min-h-screen bg-bg flex flex-col items-center justify-center px-4 py-12">
        <div className="w-full max-w-sm bg-surface border border-border rounded-xl shadow-sm p-8">
            <h1 className="text-section text-ink mb-2 text-center">
                Verification Code
            </h1>
            <p className="text-body text-ink-3 mb-8 text-center">A 6-digit code was sent to your phone.</p>

            <form onSubmit={onSubmit} className="flex flex-col items-center gap-6">
                <div className="flex gap-3">
                    {codeDigits.map((digit, idx) => (
                        <input
                            key={idx}
                            ref={inputRefs.current[idx]}
                            type="text"
                            inputMode="numeric"
                            maxLength={1}
                            className="w-12 h-12 text-center text-2xl font-bold rounded-md border-2 border-border bg-surface text-ink focus:outline-none focus:border-brand focus:ring-2 focus:ring-brand/40 transition-all"
                            value={digit}
                            onChange={e => handleChange(e, idx)}
                            onKeyDown={e => handleKeyDown(e, idx)}
                            name={`code-${idx}`}
                            autoComplete="one-time-code"
                        />
                    ))}
                </div>
                <button className="w-full bg-ink text-white rounded-lg text-label font-medium px-6 py-2 hover:bg-ink-2 transition">
                    Submit
                </button>
            </form>
        </div>
    </div>
    )
}

export default VerifyUser